import { Typography } from "@mui/material";
import React from "react";
import { useDrop } from "react-dnd";

import { useDispatch } from "../../core/context";
import { NEW_UI_SCHEMA_ELEMENT } from "../../core/dnd";
import { Actions } from "../../core/model";

export const EmptyEditor: React.FC = () => {
	const dispatch = useDispatch();

	const [{ isOver, uiSchemaElement }, drop] = useDrop({
		accept: NEW_UI_SCHEMA_ELEMENT,
		collect: (mon) => ({
			isOver: !!mon.isOver(),
			//@ts-ignore
			uiSchemaElement: mon.getItem()?.uiSchemaElement,
		}),
		drop: (): any => {
			dispatch(Actions.setUiSchema(uiSchemaElement));
		},
	});

	return (
		<div
			ref={drop}
			style={{
				padding: 10,
				fontSize: isOver ? "1.1em" : "1em",
				border: isOver ? "1px solid #D3D3D3" : "none",
				height: "100%",
			}}
		>
			<Typography data-cy={"nolayout-drop"}>Drag and drop an element from the Palette to begin.</Typography>
		</div>
	);
};
